var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 56
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__a",
  x1: "76.808%",
  x2: "45.133%",
  y1: "-18.502%",
  y2: "99.217%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#9DEDF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0061A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__b",
  x1: "54.347%",
  x2: "22.642%",
  y1: "0%",
  y2: "117.756%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#9DEDF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0061A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__c",
  x1: "134.87%",
  x2: "-37.704%",
  y1: "30.03%",
  y2: "79.634%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#9DEDF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0061A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__d",
  x1: "134.87%",
  x2: "-37.704%",
  y1: "25.036%",
  y2: "74.64%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#9DEDF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0061A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__e",
  x1: "225.692%",
  x2: "-63.094%",
  y1: "-33.888%",
  y2: "105.016%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#9DEDF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0061A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__f",
  x1: "-1.02%",
  x2: "101.02%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#0869AC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#07D3E0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__a)",
  fillRule: "nonzero",
  d: "M19.997 6.373v4.714c-5.185 0-8.366.58-9.727 1.778-1.181 1.035-1.73 3.43-1.73 7.543 0 4.113.549 6.503 1.73 7.544 1.36 1.197 4.542 1.777 9.727 1.777L8.54 40.816v-8.302c-3.663-2.016-4.867-5.766-4.867-12.111 0-10.708 3.433-14.03 16.324-14.03Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__b)",
  fillRule: "nonzero",
  d: "M31.455 20.403c0-4.108-.55-6.503-1.73-7.544-1.362-1.197-4.542-1.777-9.728-1.777L31.455 0v8.302c3.662 2.005 4.872 5.755 4.872 12.1 0 10.709-3.433 14.03-16.324 14.03v-4.714c5.18 0 8.36-.58 9.727-1.777 1.181-1.035 1.73-3.436 1.73-7.544l-.005.006Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__c)",
  fillRule: "nonzero",
  d: "M25.593 17.82H14.401a1.08 1.08 0 0 1-1.074-1.088c0-.601.48-1.088 1.074-1.088h11.192a1.08 1.08 0 0 1 1.074 1.088 1.08 1.08 0 0 1-1.074 1.088Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__d)",
  fillRule: "nonzero",
  d: "M25.593 21.902H14.401a1.08 1.08 0 0 1-1.074-1.088c0-.602.48-1.089 1.074-1.089h11.192a1.08 1.08 0 0 1 1.074 1.089 1.08 1.08 0 0 1-1.074 1.088Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__e)",
  fillRule: "nonzero",
  d: "M20.225 25.984h-5.824a1.08 1.08 0 0 1-1.074-1.089c0-.601.48-1.088 1.074-1.088h5.824a1.08 1.08 0 0 1 1.074 1.088 1.08 1.08 0 0 1-1.074 1.089Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 10.612,
  y: 43.673,
  stroke: "url(#logo_svg__f)",
  strokeWidth: 2,
  rx: 5.306
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M31.193 52.243h-.83l2.398-6.53h.817l2.398 6.53h-.83l-1.95-5.497h-.052l-1.951 5.497Zm.306-2.55h3.342v.7h-3.342v-.7ZM23.587 52.243v-6.53h.791v2.908h3.482v-2.908h.791v6.53h-.791v-2.921h-3.482v2.921zM17.21 52.243v-6.53h2.206c.513 0 .932.092 1.257.277.327.183.57.43.727.743.157.312.236.66.236 1.046 0 .385-.079.734-.236 1.049a1.753 1.753 0 0 1-.72.752c-.326.185-.743.278-1.25.278h-1.582v-.702h1.556c.35 0 .632-.06.845-.181.212-.122.366-.285.462-.491a1.64 1.64 0 0 0 .147-.705c0-.262-.05-.495-.147-.702a1.046 1.046 0 0 0-.465-.484c-.215-.12-.5-.18-.855-.18H18v5.83h-.791ZM11.39 52.243v-6.53h.791v5.829h3.036v.701zM4.885 52.251h-.829l2.398-6.53h.816l2.398 6.53H8.84l-1.951-5.498h-.051l-1.952 5.498Zm.306-2.551h3.342v.702H5.191V49.7Z"
}))));
export { SvgLogo as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNjIyNTIyNjg4NjI1Y2U0MGEyNDExODFlMWU4YzkzMDAuc3ZnIjs=";